import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreKeysEnum } from '@core/enums/store-keys.enum';
import { SystemState } from '@store/system/system-state.model';

export const selectSystemState = createFeatureSelector<SystemState>(StoreKeysEnum.SYSTEM);

export const selectLoading = createSelector(selectSystemState, state => {
    return state.loadingCount > 0;
});
